/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedNotifications } from '../../models/paginated-notifications';

export interface GetNotifications$Params {
  page: number;
  size: number;
  sort?: string;
  order?: string;
}

export function getNotifications(http: HttpClient, rootUrl: string, params: GetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedNotifications>> {
  const rb = new RequestBuilder(rootUrl, getNotifications.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('order', params.order, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedNotifications>;
    })
  );
}

getNotifications.PATH = '/in-app-notifications';
